<div class="container">
  <div #filter class="layout-row">
    <mat-form-field class="flex-fill">
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>

    <div class="action-button gap-25px">
      <button
        mat-raised-button
        color="primary"
        (click)="applyChanges()"
        [disabled]="!existAnyUpdate"
        *LOSxHasPermission="'UPDATE_EXTERNAL_EVENT_CONFIGURATION'"
      >
        {{ 'labels.buttons.Apply Changes' | translate }}
      </button>
    </div>
  </div>

  <div #eventsTable class="mat-elevation-z8 table-container">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="eventType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Event Type' | translate }}</th>
        <td mat-cell *matCellDef="let event">{{ event.type | translateKey: 'text' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Status' | translate }}</th>
        <td mat-cell *matCellDef="let event">
          <mat-slide-toggle [(ngModel)]="event.enabled" name="{{ event.type }}" (click)="toggleStatus(event)">
            <div [className]="event.enabled ? 'enabled' : 'disabled'">
              @if (event.enabled) {
                <span>{{ 'labels.inputs.Enabled' | translate }}</span>
              }
              @if (!event.enabled) {
                <span>{{ 'labels.inputs.Disabled' | translate }}</span>
              }
            </div>
          </mat-slide-toggle>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="select-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
